import {
  ColdArticleEntity,
  TranslationEntity,
  ProfileEntity,
  RSEEntity,
  SliderPopinEntity,
  TimelinePopinEntity,
  LaPosteEn4Entity,
  FooterEntity,
  HeaderEntity,
  HomeEntity,
  HotArticleEntity,
  NewsroomEntity,
  MediaPopinEntity,
  SearchEntity,
  HubActusEntity,
  HubNewsroomEntity,
  PressReleaseEntity,
} from '@lglp/prismic-client';
import { schema } from 'normalizr';

import { DocumentType, TranslationType } from '../../../types/document';
import { MEDIA_TYPE } from '../../../types/press-media';
import { toDocType, toMediaType } from '../mapping';
import {
  ContactEntity,
  FinancialDebtEntity,
  FinancialKeyFiguresEntity,
  FinancialPressReleaseEntity,
  FinancialPublicationEntity,
  FinancialRatingEntity,
} from './documents';
import {
  MediaPressEntity,
  MediaPressReleaseEntity,
} from './documents/media-press';
// import { PressReleaseEntity } from './documents/press-release';

const isTranslation = (type?: string): boolean =>
  type.startsWith('translation_');

/**
 * Normalizr schema representing a document
 */
export const CustomType = new schema.Union(
  {
    [DocumentType.CONTACT]: ContactEntity,
    [DocumentType.COLD_ARTICLE]: ColdArticleEntity,
    [DocumentType.FINANCIAL_DEBT]: FinancialDebtEntity,
    [DocumentType.FINANCIAL_KEY_FIGURES]: FinancialKeyFiguresEntity,
    [DocumentType.FINANCIAL_PRESS_RELEASE]: FinancialPressReleaseEntity,
    [DocumentType.FINANCIAL_PUBLICATION]: FinancialPublicationEntity,
    [DocumentType.FINANCIAL_RATING]: FinancialRatingEntity,
    [DocumentType.FOOTER]: FooterEntity,
    [DocumentType.HEADER]: HeaderEntity,
    [DocumentType.HOME]: HomeEntity,
    [DocumentType.HOT_ARTICLE]: HotArticleEntity,
    [DocumentType.HUB_ACTUS]: HubActusEntity,
    [DocumentType.HUB_NEWSROOM]: HubNewsroomEntity,
    [DocumentType.LA_POSTE_EN_4]: LaPosteEn4Entity,
    [DocumentType.MEDIA_POPIN]: MediaPopinEntity,
    [DocumentType.MEDIA_PRESS]: MediaPressEntity,
    [DocumentType.MEDIA_PRESS_RELEASE]: MediaPressReleaseEntity,
    [DocumentType.NEWSROOM]: NewsroomEntity,
    [DocumentType.PRESS_RELEASE]: PressReleaseEntity,
    [DocumentType.PROFILE]: ProfileEntity,
    [DocumentType.RSE]: RSEEntity,
    [DocumentType.SEARCH]: SearchEntity,
    [DocumentType.SLIDER_POPIN]: SliderPopinEntity,
    [DocumentType.TIMELINE_POPIN]: TimelinePopinEntity,

    [TranslationType.TRANSLATION]: TranslationEntity,
  },
  (entity) => {
    if (
      toDocType(entity?.type) === DocumentType.MEDIA_PRESS &&
      toMediaType(entity?.data?.category) === MEDIA_TYPE.RELEASE
    ) {
      return DocumentType.MEDIA_PRESS_RELEASE;
    } else if (isTranslation(entity?.type)) {
      return TranslationType.TRANSLATION;
    }

    return toDocType(entity?.type);
  }
);

/**
 * Normalizr schema representing an array of documents
 */
export const CustomTypes = [CustomType];
